export { default } from './BarChartMonitoring';
